module.exports = __webpack_public_path__ + "static/media/a2.4d8d2e5a.jpg";